import React from "react";
import AppHomeFramelessFlow from "@/components/home/AppHomeFramelessFlow";

export default function Home() {
  return <AppHomeFramelessFlow />;
}